import React, { Component } from 'react';
import { connect } from 'react-redux';
import strings from '../../components/locales';

class Authorization extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div className="main messageComponent">
        <div>
          <h4>{strings.error.noAuthorization}</h4>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
});

Authorization.propTypes = {

};

export default connect(mapStateToProps,mapDispatchToProps)(Authorization);




// WEBPACK FOOTER //
// ./source/client/containers/authorization/index.jsx